var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCancelClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_91_3055)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 2C6.46976 2 1.99976 6.47 1.99976 12C1.99976 17.53 6.46976 22 11.9998 22C17.5298 22 21.9998 17.53 21.9998 12C21.9998 6.47 17.5298 2 11.9998 2ZM16.2998 16.3C15.9098 16.69 15.2798 16.69 14.8898 16.3L11.9998 13.41L9.10976 16.3C8.71976 16.69 8.08976 16.69 7.69976 16.3C7.30976 15.91 7.30976 15.28 7.69976 14.89L10.5898 12L7.69976 9.11C7.30976 8.72 7.30976 8.09 7.69976 7.7C8.08976 7.31 8.71976 7.31 9.10976 7.7L11.9998 10.59L14.8898 7.7C15.2798 7.31 15.9098 7.31 16.2998 7.7C16.6898 8.09 16.6898 8.72 16.2998 9.11L13.4098 12L16.2998 14.89C16.6798 15.27 16.6798 15.91 16.2998 16.3Z",
    fill: "#4E5968"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_91_3055"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelClose);
export default __webpack_public_path__ + "static/media/CancelClose.a9d88cab31368249ced3b2b6a5db9c3d.svg";
export { ForwardRef as ReactComponent };